import React from "react";
import PropTypes from "prop-types";

const Line = (props) => {
  const { class: className } = props.config;
  return <hr className={`form__line ${className !== null ? className : ""}`} />;
};

Line.propTypes = {
  config: PropTypes.object.isRequired,
};

export default Line;



// WEBPACK FOOTER //
// ./src/components/FormTemplates/Content/Line.js